import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ExtraOptions, NoPreloading, RouterModule } from '@angular/router';
import { FuseMockApiModule, FuseModule } from 'fuseui';
import { FuseConfigModule } from 'fuseui';
import { appConfig } from './core/config/app.config';

import { AppComponent } from './app.component';
import { appRoutes } from './app.routing';
import { CoreModule } from './core/core.module';

import { mockApiServices } from './mock-api';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { StingModule } from '../../../../libs/sting/src/lib/sting.module';
import { ToastrModule } from 'ngx-toastr';
import { registerLocaleData } from '@angular/common';
import localeCs from '@angular/common/locales/cs';
import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';
import { GoogleGeoModule } from '../../../../libs/sting/src/lib/utils/google-geo/google-geo.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { LayoutModule } from 'sting';
import { NgxTranslateCacheBusterLoader } from './core/transloco/ngx-translate-cache-buster.loader';
import { environment } from '../environments/environment';
import { BASE_PATH as API_BASE_PATH } from '../../../../libs/sting/src/lib/api/variables';
import { BASE_PATH as API_USERS_BASE_PATH } from '../../../../libs/sting/src/lib/api-users/variables';
import { BASE_PATH as INTERNAL_API_BASE_PATH } from '../../../../libs/sting/src/lib/api-internal/variables';

const routerConfig: ExtraOptions = {
    preloadingStrategy: NoPreloading,
    scrollPositionRestoration: 'enabled',
};

registerLocaleData(localeCs);

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, routerConfig),

        // Fuse, FuseConfig & FuseMockAPI
        FuseModule,
        StingModule,
        FuseConfigModule.forRoot(appConfig),
        FuseMockApiModule.forRoot(mockApiServices),
        // Core module of your application
        CoreModule,
        // Layout module of your application
        LayoutModule,

        BrowserAnimationsModule, // required animations module
        ToastrModule.forRoot(), // ToastrModule added
        AngularSvgIconModule.forRoot(),

        // Translate module
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (http: HttpClient) => new NgxTranslateCacheBusterLoader(http),
                deps: [HttpClient],
            },
        }),

        MatGoogleMapsAutocompleteModule,
        GoogleGeoModule,
    ],
    providers: [
        {
            provide: API_BASE_PATH,
            useValue: environment.apiBaseUrl,
        },
        {
            provide: API_USERS_BASE_PATH,
            useValue: environment.apiUsersBaseUrl,
        },
        {
            provide: INTERNAL_API_BASE_PATH,
            useValue: environment.apiInternalBaseUrl,
        },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}

